import { render, staticRenderFns } from "./FreePlanInterceptionDialog.vue?vue&type=template&id=96c0adc4&scoped=true"
import script from "./FreePlanInterceptionDialog.vue?vue&type=script&lang=ts"
export * from "./FreePlanInterceptionDialog.vue?vue&type=script&lang=ts"
import style0 from "./FreePlanInterceptionDialog.vue?vue&type=style&index=0&id=96c0adc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c0adc4",
  null
  
)

export default component.exports